import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import SlotsTable from './SlotsTable'
import { axiosInstance } from '../Config'
import secureLocalStorage from 'react-secure-storage'
import Loader from '../Loader'
import swal from 'sweetalert'
import { toast } from 'react-toastify'

const SlotsIndex = () => {
 
    const users = secureLocalStorage.getItem("credentials");
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0)
        getDaysInfo()
    }, [])

    function getDaysInfo() {
        setLoading(true)

        axiosInstance.get(`/get-slots/${users.id}`, {
            headers: {
                Authorization: `Bearer ${users.token}`
            }
        })

        // axiosInstance.get(`/get-slots/${users.id}`, {
        //     headers: {
        //         Authorization: `Bearer ${users.token}`
        //     }
        // })
            .then(res => {

                const fullWeekData = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => {

                    const existingSlot = res?.data?.Slots ? res?.data?.Slots.find(slot => slot.days === day) : "";
                    if (existingSlot) {
                        return existingSlot;  // If there's a slot for this day, keep the existing slot
                    } else {
                        return {
                            id: null,  // If no slot exists, set id to null
                            instructorid: users.id,
                            days: day,
                            slots: "[]",  // Empty array for slots
                            status: "1"
                        };
                    }
                });

                setData(fullWeekData)
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    const navigate = useNavigate()

    const [items_perpage, setItemsPerPage] = useState(10)

    const total_pages = Math.ceil(data?.length / items_perpage);

    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const onChangeStatus = (day_id, curr_status) => {
        if (day_id === null) {
            swal("", "You do not have any slots on this day, hence you could not be available.", "error")
            return;
        }

        swal({
            title: "Are you sure?",
            text: `You will be ${Number(curr_status) === 0 ? 'unavailable' : 'available'} on this day.`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {

                    setLoading(true)

                    const formData = {
                        userid: secureLocalStorage.getItem('credentials')?.id,
                        slotid: day_id
                    }

                    axiosInstance.post('/update-slots', formData, {
                        headers: {
                            Authorization: `Bearer ${users.token}`
                        }
                    })
                        .then((response) => {

                            // console.log(response)
                            if (response.data.success == false) {
                                swal("", "You do not have any slots on this day, hence you could not be available.", "success")
                                return
                            }

                            if (response.data.success == true) {
                                swal("", "Availability Status Changed Successfully", "success")
                                const updatedData = data.map(item =>
                                    item.id === day_id ? { ...item, status: Number(curr_status) === 1 ? 0 : 1 } : item
                                );
                                setData(updatedData);
                                // console.log(response.data.data)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            swal("", "Something Went Wrong!", "error")
                        })
                        .finally(() => setLoading(false))
                }
            });
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Slots Availability" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                <div className='text-end mb-4'>

                                    <div>
                                        {/* <button type="button" className="button btn-green  color-white">
                                            <i className='icon-plus me-3 fs-5'></i>
                                            Add Customer</button> */}
                                        <button type="button" onClick={() => navigate(-1)} className="button btn-black text-white ms-3">
                                            <i className='icon-arrow-left me-3 fs-5'></i>
                                            back</button>
                                    </div>

                                </div>

                                <SlotsTable data={final_data} onChangeStatus={onChangeStatus} />

                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>

                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`}
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>

                                        {
                                            [...Array(total_pages)].map((_, pagecount) => {
                                                pagecount += 1
                                                return (
                                                    <>
                                                        <div key={pagecount} className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === pagecount && 'activepage'}`} onClick={() => changePage(pagecount)}>
                                                            {pagecount < 10 ? ('0' + pagecount) : pagecount}
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }

                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`}
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default SlotsIndex